import { createSelector } from '@reduxjs/toolkit';
import {
  FEATURE_TYPE,
  isNumber,
  selectApp,
  selectFeatureTypes,
  SELECTOR,
  selectSplitApiKey,
  setSelector,
} from '@socialive/common';
import selectSplitAttributes from './selectSplitAttributes';

// NOTE: This selector is used by `initAndLoadSplitsForApp`.  By default it assumes that the account and user are
// required in order to initialize split (app feature flags are treated like account feature flags). Any application
// that needs app feature flags available without account/user (like Portal) will need to override this selector.
const selectSplitInit = createSelector(
  selectFeatureTypes,
  selectSplitApiKey,
  selectApp,
  selectSplitAttributes,
  (featureTypes, authorizationKey, app, { accountId, userId } = {}) =>
    authorizationKey &&
    (!featureTypes?.[FEATURE_TYPE.APP] || app) &&
    (!featureTypes?.[FEATURE_TYPE.ACCOUNT] || (isNumber(accountId) && isNumber(userId))) && {
      authorizationKey,
      app,
      featureTypes,
    }
);

setSelector(SELECTOR.SPLIT_INIT, selectSplitInit);

export default selectSplitInit;
